import React, { useRef } from "react";
import { BtnUploadSwing, HeaderChat, HeaderChatMessage, HeaderChatMessageUploadBox, HeaderInideMessage, TypoHeaderCInsideSubTitle, TypoHeaderInisideTitle } from "../chatStyled";
import { Box } from "@mui/material";
import { SendbirdUser } from "../chat";

interface InsideHeaderProps {
    Title: string;
    SubTitle: string;
    ButtonText: string;
    ButtonIcon: React.ReactElement;
    Message: string;
    onLoadFile: (file: File) => void;
    user?: SendbirdUser;
    isBlocked?: boolean;
    onBlockedAction?: () => void;
}

const InsideHeader: React.FC<InsideHeaderProps> = (props) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    
    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            props.onLoadFile?.(file);
        }
    };
    
    const handleClick = () => {
        if (props.isBlocked) {
            props.onBlockedAction?.();
            return;
        }
        if (!props?.user?.user_id) return; // Prevent action if user is not loaded
        fileInputRef.current?.click();
    };
    
    return (
        <HeaderChat>
            <HeaderChatMessage>
                <HeaderChatMessageUploadBox>
                    <Box>
                        <TypoHeaderInisideTitle>
                            {props.Title}
                        </TypoHeaderInisideTitle>
                        <TypoHeaderCInsideSubTitle>
                            {props.SubTitle}
                        </TypoHeaderCInsideSubTitle>
                    </Box>
                    <Box>
                        <BtnUploadSwing onClick={handleClick}>
                            <span>{props.ButtonIcon}</span>
                            {props.ButtonText}
                        </BtnUploadSwing>
                    </Box>
                </HeaderChatMessageUploadBox>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="video/*"
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                />
                <HeaderInideMessage dangerouslySetInnerHTML={{ __html: props.Message }} />
            </HeaderChatMessage>
        </HeaderChat>
    );
}

export default InsideHeader;